import { Theme } from "./theme.model";

export const THEMES: Theme[] = [
  {
    host: ['default'],
    partialHost: 'default',
    name: 'default',
    brandCode: 'SD',
    icon: 'assets/imgs/sandaya-logo.png',
    favicon: 'assets/favicons/default-favicon.ico',
    title: 'Sandaya',
  },
  {
    host: [
      'localhost',
      'wallet-dev.guestup.com',
      'wallet-test.guestup.com',
      'sandaya.guestup.com',
    ],
    partialHost: 'sandaya',
    name: 'sandaya',
    brandCode: 'SD',
    icon: 'assets/imgs/sandaya-logo.png',
    favicon: 'assets/favicons/sandaya-favicon.ico',
    title: 'Sandaya',
  },
  {
    host: [
      'plopsa-dev.guestup.com',
      'plopsa-test.guestup.com',
      'plopsa.guestup.com',
      'magicoband.plopsa.com',
    ],
    partialHost: 'plopsa',
    name: 'plopsa',
    brandCode: 'PLO',
    icon: 'assets/imgs/plopsa-logo.png',
    favicon: 'assets/favicons/plopsa-favicon.ico',
    title: 'Plopsa',
  },
];
